// @flow
import React, { type ComponentType } from 'react';
import { Route, Redirect } from 'react-router-dom';
import routes from 'constants/routes';

type OwnProps = {
  component?: ComponentType<*>,
  children?: React$Node,
};

type Props = {
  ...OwnProps,
  isAuthenticated: boolean,
};

const ProtectedRoute = ({
  component, isAuthenticated, ...rest
}: Props) => (
  <Route
    /* eslint-disable-next-line react/jsx-props-no-spreading */
    {...rest}
    component={
        localStorage.getItem('accessToken') && localStorage.getItem('accessToken') !== undefined
          ? component
          : () => (
            <Redirect
              to={{
                pathname: routes.auth.signIn.root,
              }}
            />
          )
      }
  />
);
export default ProtectedRoute;
